<template>
        <div class="edits setting">
            <div class="setting-h1" v-if="canAccess('enterprise-my-account')">
                Business Information
            </div>
            <div class="setting-h1" v-else>
                Profile Information
            </div>
            <div class="setting-h2" v-if="canAccess('enterprise-my-account')">
                Edit you company profile information. The information added to this section is for the public domain.
            </div>
            <div class="setting-h2" v-else>
                Edit your profile information. Also note that changes made here will apply to your CV.
            </div>
        <form @submit.prevent="editProfile">
    
        <div class="mb-3">
        <label class="form-label" v-if="canAccess('enterprise-my-account')">Business Name</label>
        <label class="form-label" v-else>Fullname</label>
        <input type="text" placeholder="Fullname" v-model="user.fullname" class="form-control">
        </div>
         <div v-if="canAccess('enterprise-my-account')" class="mb-3">
            <label class="form-label">Vocation ID</label>
            <input type="text" placeholder="Unique Vocation ID" v-model="user.handle" class="form-control">
        </div>
        <div v-if="canAccess('enterprise-my-account')" class="mb-3">
            <div class="label-area">
                <label class="form-label">Bio</label>
                <div class="count" :class="{ 'limit': remainingCount < 0 }">{{ remainingCount }}</div>
            </div>
            <textarea @keyup="updateCount()" placeholder="About Your Organization..." v-model="user.description" class="form-control form-text"></textarea>
        </div>
        <div class="mb-3" v-if="!canAccess('enterprise-my-account')">
            <label class="form-label">Professional Title</label>
            <input type="text" placeholder="e.g. Accountant, Engineer, Superstar" v-model="user.title" class="form-control">
        </div>
         <div class="mb-3">
            <label class="form-label">Website URL</label>
            <input type="text" placeholder="Website / Social Media" v-model="user.website" class="form-control">
        </div>
         <div class="mb-3">
            <label class="form-label" v-if="canAccess('enterprise-my-account')">Business Phone</label>
            <label class="form-label" v-else>Phone</label>
            <input type="text" placeholder="Phone" v-model="user.phone" class="form-control">
        </div>
        <div class="mb-3">
        </div>
         <div class="form-buttons mb-3">

                <button submit class="btn btn-default primary-btn" v-if="loading" disabled="">Saving Profile...</button>
                <button submit class="btn btn-default primary-btn" v-else>Save Profile</button>
    
            </div>
            <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors --> 
        </form>
        <!-- <LoadingIndicator v-if="loading"/> -->
        </div>
        <ConfirmationMessageModal :title="modal.caption" :body="modal.message" :button-label="modalButtonLabel" :close-modal="() => closeModal()"/>
</template>
<script>
import { canAccess as authCanAccess } from '@/services/authService';
import { editProfileAsync } from '@/services/accountService';
import ConfirmationMessageModal from '@/components/modals/ConfirmationMessageModal.vue';
import Modal from 'bootstrap/js/dist/modal';
export default {
    components:{
        ConfirmationMessageModal
    },
    data(){
        return{
            url: process.env.VUE_APP_API_URL,
            user:{
                    fullname:"",
                    handle:"",
                    description:"",
                    phone:"",
                    title:"",
                    website:"",
                    email:"",         
                },
            modal:{
                caption:"",
                message:""
            },
            confirmModal: null,
            errors:[],
            loading:false,
            hasErrors:false,
            modalButtonLabel:'Close',
            maxBioLength: 300
            
        }
    },
    computed:{
        remainingCount() {
        const currentLength = this.user.description ? this.user.description.length : 0;
        return this.maxBioLength - currentLength;
    }
    },
     mounted(){
        this.confirmModal = new Modal(document.getElementById('confirmMessageModal'))
    },
    created(){
          // Hydrate local user object from Vuex
        const authUser = this.$store.getters['auth/getAuthenticatedUser'];
        if (authUser) {
            this.user.fullname = authUser.fullname || "";
            this.user.handle = authUser.handle || "";
            this.user.description = authUser.description || "";
            this.user.phone = authUser.phone || "";
            this.user.title = authUser.title || "";
            this.user.website = authUser.website || "";
            this.user.email = authUser.email || "";
        }
    },
    methods:{
        updateCount(){
            let bioLength = this.user.description.length;
            this.letterCount -= bioLength;
        },
        canAccess(path){
            return authCanAccess(path);
        },
     async editProfile(){
        try{
            this.resetOnNewSubmit();
            var data = await editProfileAsync(this.user);
            this.loading = false;
            if(data.success){
                this.$store.dispatch('auth/updateProfile', { user: this.user });
                this.modal.caption = data.caption;
                this.modal.message = data.message;
                this.showModal();
        }else{
            if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                });
                this.hasErrors = true;
                return;
            }
             throw new Error(data.message, {cause: data.caption})
        }
        }catch(e){
            this.loading = false;
            let message = e.message || "Something went wrong. Please try later";
            this.errors.push(message);
            this.hasErrors = true;
            // this.modal.caption = e.cause || "Error";
            // this.modal.message = e.message || "Something went wrong. Please try later";
            // this.modalButtonLabel = 'Close'
            // this.showModal();
        }     
        },
        resetOnNewSubmit(){
                this.loading = true;
                this.hasErrors = false;
                this.errors = [];
        },
        closeModal(){
        this.confirmModal.hide();
        },
        showModal(){
            this.confirmModal.show();
        }
   }
    

}
</script>
<style scoped>

.label-area{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.count{
    color:var(--page-header);
    font-family: var(--heading-font-regular);
    font-size:0.9rem;
}

.limit{
    color:var(--red)!important;
}

.form-text{
    height:13rem;
    border-radius:8px;
    resize: none;
    border:1px solid var(--input-outline)!important;
  background-color:var(--input-background)!important;
  color:var(--foreground)!important;
}
.edit-profile{
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    margin:4.5rem 0rem;
}

.edits{
    grid-column:2/3;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
}
}
</style>